module.exports = "<div class=\"box box-2\"> <div class=\"box-hd clearfix\"> <div class=left> <h3>Verzenden naar</h3> </div> <div class=right> <a href=# ng-click=vm.onEditStep1() class=\"btn btn-outline btn-tile pod-btn-edit\"><i class=\"ico ico-edit\"></i></a> </div> </div> <div class=box-bd> <div class=pod-icon-item> <div class=pod-icon> <i class=\"ico ico-location-2 text-success ico-large\"></i> </div> <div class=pod-item> <order-receiver-detail receiver=::vm.receiver></order-receiver-detail> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/components/add-step1-select-receiver-read.html
// module id = 522
// module chunks = 0